import React from 'react';
import {Input, RemoveButton, RequiredButton} from '../../ui';
import {deleteOption, setFields} from '../../service/createForm.slice';
import {useDispatch} from 'react-redux';
import {useRemoveField, useToggleRequired} from '../../model';

import './index.scss';
import {
  AcceptableIcon,
  CloseIcon,
  CommentIcon,
  ConditionIcon,
} from '../../icons';
import {Tooltip} from 'react-tooltip';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function ConditionCode({field, idx}) {
  const dispatch = useDispatch();
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);
  const {removeField} = useRemoveField();
  const {toggleRequired} = useToggleRequired();
  const {t} = useTranslation();
  const handleRequired = () => toggleRequired(idx);

  const handleChange = e => {
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };

  const handleOptionLabel = (e, index) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'options',
        index,
        value: e.target.value,
        key: 'label',
      }),
    );
  };

  const handleRemove = () => removeField(idx);

  const handleStatus = (key, index, value) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'options',
        value: value,
        index,
        key,
      }),
    );
  };

  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
          value={field?.label}
          disabled={isReadOnly}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'condition-remove'}
              idx={idx}
              id={'condition'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-type'>
        <ConditionIcon />
        <span>{t('createNewForm.components.conditionCode')}</span>
      </div>
      <div className='f-build__general-options'>
        {field?.options?.map((option, index) => (
          <div className='f-build__general-option' key={index}>
            <Input
              value={option?.label}
              disabled={
                isReadOnly ? true : option?.label === 'Comment' ? true : false
              }
              placeholder={`${t('createNewForm.components.option')} ${index + 1}`}
              key={`input-${idx}-${index}`}
              onChange={e => handleOptionLabel(e, index)}
            />
            {!isReadOnly && (
              <>
                <div
                  className='f-build__radio-icon'
                  onClick={() =>
                    handleStatus('acceptable', index, !option?.acceptable)
                  }
                  data-tooltip-id={`acceptable-radio-${idx}-${index}`}
                  data-tooltip-content={t('createNewForm.components.acceptable')}
                >
                  <AcceptableIcon active={option?.acceptable} />
                  <Tooltip
                    id={`acceptable-radio-${idx}-${index}`}
                    place={'top-end'}
                  />
                </div>
                <div
                  className='f-build__general-icon'
                  onClick={() =>
                    handleStatus('has_comment', index, !option?.has_comment)
                  }
                  data-tooltip-id={`comment-condition-${idx}-${index}`}
                  data-tooltip-content={t('createNewForm.components.comment')}
                >
                  <CommentIcon active={option?.has_comment} />
                  <Tooltip
                    id={`comment-condition-${idx}-${index}`}
                    place={'top-end'}
                  />
                </div>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ConditionCode;
